module.exports = __webpack_public_path__ + "img/robot_icon.549fa1d3.jpg";